import { ITeamLeadPodTypeJson } from '@scale/shared/types/expertManagement';
import { useQuery } from 'react-query';
import { fetchUserInfo } from 'react-scale/components/ExpertManagement/ExpertManagementPage/api';
import { UserInfo } from 'react-scale/components/ExpertManagement/ExpertManagementPage/types';
import {
  setPodTypeFilterSelector,
  useStatContextStore,
} from 'react-scale/components/ExpertManagement/stores/statContext.store';
import {
  setUserInfoSelector,
  useUserInfoStore,
} from 'react-scale/components/ExpertManagement/stores/userInfo.store';
import { defaultApiFetchErrorHandler } from 'react-scale/lib/api-fetch';
import { shallow } from 'zustand/shallow';

// TODO: there's too many to keep track of and this part of the code is not typed so suppress errs for now
// Also, I have no idea whether these types are actually optional
// This is to prevent future people from stumbling into undefined excpetions
interface UseFetchUserInfoResponse {
  data?: {
    teamLeadPodType?: ITeamLeadPodTypeJson;
    id: $FIXME;
    name: $FIXME;
    email: $FIXME;
    role: $FIXME;
    manager: $FIXME;
    [key: string]: $FIXME;
  };
  status?: string;
  [key: string]: $FIXME;
}

export const useFetchUserInfo = (
  userId: string,
  suppressError: boolean = false,
): UseFetchUserInfoResponse => {
  const setUserInfo = useUserInfoStore(setUserInfoSelector, shallow);
  const setPodTypeFilter = useStatContextStore(setPodTypeFilterSelector, shallow);
  return useQuery([`userInfo`, userId], () => fetchUserInfo(userId), {
    onSuccess: data => {
      if (data?.teamLeadPodType?._id !== undefined) {
        setPodTypeFilter(data?.teamLeadPodType?._id);
      }
      if (data !== undefined && data.teamLeadPodType !== undefined) {
        setUserInfo(data as UserInfo);
      } else {
        setUserInfo(undefined);
        if (!suppressError) {
          defaultApiFetchErrorHandler(
            {
              logError: () => null,
              name: 'Error',
              message: `User ${userId} does not exist in the TLD`,
            },
            { handleHttp: true },
          );
        }
      }
    },
  });
};
